enum FormValidity {
  Valid,
  Invalid,
  Pending,
}

export default FormValidity;
